import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonLabel,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import {
  weltico2BlancType,
  weltico2CouleurType,
} from '../../../../../../../../components/ecosystems/function-parameters-settings-weltico2-clock-screen/function-parameters-settings-weltico2-clock-screen.component';
import {
  getHorlogeTotalTime,
  transformWeltico2BufferToModel,
  transformWeltico2ModelToBuffer,
  Weltico2HorlogeModel,
} from '../../../../../../helper/horloge';
import { convertMinutesToTime } from '../../../../../../helper/convertSecondsToTime';
import Moment from 'moment';
import moment from 'moment';

@Component({
  selector: 'app-p00039-weltico-v2-color-choice',
  templateUrl: './p00039-weltico-v2-color-choice.component.html',
  styleUrls: ['./p00039-weltico-v2-color-choice.component.scss'],
  imports: [IonButton, IonContent, IonFooter, IonLabel, TranslatePipe],
})
export class P00039WelticoV2ColorChoiceComponent implements OnInit {
  private modalController = inject(ModalController);

  @Input() value: string = '';
  @Input() colorType: number = 3;

  public welticoColors: any = weltico2CouleurType;

  constructor() {}

  ngOnInit() {
    if (this.colorType === 3) {
      this.welticoColors = weltico2CouleurType;
    } else {
      this.welticoColors = weltico2BlancType;
    }
  }

  async selectColor(value: number) {
    await this.modalController.dismiss({ value: value });
  }

  async dismissModal(): Promise<void> {
    await this.modalController.dismiss();
  }
}
